<template>
  <div class="container">
    <h1 class="text-danger"><i class="fa fa-heartbeat"></i> Monitor Oscar Pool Event Streams</h1>

    <div class="connections-summary">
      <h3>{{connectionsCount}} connection{{ (connectionsCount === 1)? '' : 's' }} from {{clubCount}} club{{ (clubCount === 1)? '' : 's' }}</h3>

      <div class="form-check form-switch text-secondary">
        <input class="form-check-input" type="checkbox" id="playSoundOnUpdate" v-model="playSoundOnUpdate">
        <label class="form-check-label" for="playSoundOnUpdate">play update sounds</label>
      </div>

    </div>

    <ul>
      <li v-for="(connection_group) in oscarPoolStreamsData" :key="connection_group.oscar_pool_info.oscar_pool_id" class="">
        <div class="club-header"><ClubPicture :club="connection_group.oscar_pool_info" size="25"></ClubPicture> <b>{{connection_group.oscar_pool_info.name}}</b> <span class="document-id">(pool {{connection_group.oscar_pool_info.oscar_pool_id}})</span></div>
        <table class="connection-table">
          <tbody>
            <tr v-for="(connection) in connection_group.connections" :key="connection.stream_id">
              <td>
                <ProfilePicture :user="connection" :size="20"></ProfilePicture> <ProfileName :user="connection"></ProfileName>
              </td>
              <td>
                <span class="connection-time"><i class="fa fa-bolt"></i> {{(new Date(connection.stream_start)).toLocaleTimeString()}}</span>
              </td>
              <td>
                {{connection.dyno}}
              </td>
              <td>
                <span class="document-id">(user {{connection.user_id }})</span>
              </td>
            </tr>
          </tbody>
        </table>
      </li>
    </ul>

<!--
    <div>
      <pre>{{JSON.stringify(oscarPoolStreamsData, null, 2)}}</pre>
    </div>
-->

  </div>
</template>


<script>
import ClubPicture from "@/components/clubs/ClubPicture.vue";
import ProfileName from "@/components/profile/ProfileName.vue";
import ProfilePicture from "@/components/profile/ProfilePicture.vue";

export default {
  name: "AdminMonitorOscarPoolEventStreams",
  components: {ProfilePicture, ProfileName, ClubPicture},
  data() {
    return {
      eventSource: null,
      oscarPoolStreamsData: null,
      playSoundOnUpdate: false,
      updateSound: new Audio(this.$imagePathBase + 'audio/ding.mp3'),
    }
  },
  created() {
    // Initialize the EventSource, listening for server updates
    this.eventSource = new EventSource(`${this.$apiPath}/api/club/oscar-pool/admin/monitor-event-streams`);
    this.eventSource.addEventListener('oscarPoolResultStreamUpdate', this.onEventStreamsUpdate);
    this.eventSource.addEventListener('closeConnection', this.onConnectionClosedEvent);

    this.eventSource.onerror = this.onConnectionError;
    this.eventSource.onopen = this.onConnectionOpen;
  },
  beforeUnmount() {
    this.eventSource?.close();
  },
  computed: {
    clubCount() {
      return this.oscarPoolStreamsData?.length ?? 0;
    },
    connectionsCount() {
      if ( !this.oscarPoolStreamsData ) {
        return 0;
      }

      return this.oscarPoolStreamsData.reduce((accNumConnections, curPool) => {
        return accNumConnections + curPool.connections.length;
      }, 0);
    }
  },

  watch: {
    playSoundOnUpdate(newValue /*,oldValue*/) {
      // ding when turned on
      if ( newValue ) {
        this.updateSound.play();
      }
    }
  },

  methods: {
    onEventStreamsUpdate(event) {

    /*
    [
        {
          "oscar_pool_info": {
            "oscar_pool_id": "6993805fc8d61ba61e5e364e",
            "club_id": "6993805fc8d61ba61e5e364c",
            "name": "Andy's Pool",
            "picture_url": "http://myoscarlist.s3.us-east-2.amazonaws.com/club-pics/default-club-pic.png"
          },
          "connections": [
            {
              "stream_id": "3e21f884-e274-495a-93d1-7366dfbd52b2",
              "stream_start": "2026-03-05T23:27:33.637Z",
              "user_id": "699359c6328b34c0e899db2b",
              "username": "Bobby (202)",
              "picture_url": "http://myoscarlist.s3.us-east-2.amazonaws.com/profile-pics/default-profile-pic.png"
            },
            {
              "stream_id": "72a6b865-8dc1-4da8-af3c-a984542974e0",
              "stream_start": "2026-03-05T23:27:33.860Z",
              "user_id": "698cacab4532446e4592e962",
              "username": "Andy (201)",
              "picture_url": "http://myoscarlist.s3.us-east-2.amazonaws.com/profile-pics/default-profile-pic.png"
            }
          ]
        }
      ]
      */

      this.oscarPoolStreamsData = JSON.parse(event.data);
      //console.log('oscarPoolStreamsData', this.oscarPoolStreamsData);

      if ( this.playSoundOnUpdate ) {
        this.updateSound.play();
      }
    },

    onConnectionClosedEvent(/*event*/) {
      this.eventSource.close();
      this.updateConnectionReadyState();
    },
  }
}
</script>


<style scoped>


ul {
  list-style-type: none;
}

li {
  padding-top: 0.75em;
}

.connection-time {
}

.document-id {
  font-family: var(--bs-font-monospace);
  opacity: 40%;
  font-size: smaller;
}

.fa-bolt, .fa-server {
  color: var(--bs-secondary);
  font-size: smaller;
}

.club-header {
  white-space: nowrap;
}

.connection-table {
  margin-left: 1em;

  td {
    white-space: nowrap;
    padding-right: 1em;
  }
}

.connections-move,
.connections-enter-active,
.connections-leave-active {
  transition: all 0.5s ease;
}


.connections-summary {
  margin-top: 2em;
  margin-bottom: 2em;
}


</style>